export default {
  "content": "<path d=\"M8 5.733L15.294.059A.993.993 0 0015 0H1C.9.005.8.025.706.059L8 5.733z\" fill=\"#717684\"/><path d=\"M8.614 7.79a1 1 0 01-1.228 0L0 2.045V9a1 1 0 001 1h14a1 1 0 001-1V2.045L8.614 7.79z\" fill=\"#717684\"/>",
  "attrs": {
    "width": "16",
    "height": "10",
    "viewBox": "0 0 16 10",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};